<script lang="ts" setup>
import { useTokenType } from '~/composables/useTokenType'
import { nftDetailPageTab } from '~/routes/nfts'
import { ITab } from '~/types/tab.type'
import { INftType } from '~/types/token-type.type'
import BcTabs from '~/ui/Tabs/BcTabs.vue'
import { getRouteParam } from '~/utils/route.util'

type INftTab = ITab<nftDetailPageTab>

const route = useRoute()
const router = useRouter()
const { tokenTypeValue } = useTokenType<INftType>()

const address = getRouteParam('address')
const tabList = computed(() => {
  const tab: INftTab[] = [
    {
      value: nftDetailPageTab.transfers,
      label: 'Transfers',
    },
    {
      value: nftDetailPageTab.holders,
      label: 'Holders',
    },
    {
      value: nftDetailPageTab.inventory,
      label: 'Inventory',
    },
    {
      value: nftDetailPageTab['contract-code'],
      label: 'Contract Code',
    },
    {
      value: nftDetailPageTab.info,
      label: 'NFT Info',
    },
  ]
  return tab
})

const extractTabFromPath = (path: string) => {
  return path.split('/').at(-1) as nftDetailPageTab || nftDetailPageTab.transfers
}

const tab = ref(extractTabFromPath(route.path))

watch(tab, () => {
  router.replace(routes.getNftDetailPageWithTab(tokenTypeValue, address, tab.value))
})
</script>

<template>
  <BcTabs
    v-model="tab"
    :list="tabList"
  />
</template>

<style scoped>

</style>
